import React from 'react';
import PageTemplate from '../../components/PageTemplate';

const WebsiteDevelopment = () => {
  return (
    <PageTemplate title="Website Development" subtitle="Modern, responsive websites" breadcrumb="Applications > Website Development">
      <div className="content-section">
        <h3>Custom Website Development</h3>
        <p>Professional website development services using the latest technologies.</p>
      </div>
    </PageTemplate>
  );
};

export default WebsiteDevelopment; 